"use client";

import React from "react";
import Image from "next/image";
import NSDC from "@/assets/logo/NSDC.png"
import TTAADC from "@/assets/logo/TTAADC.webp"
const approvals = [
  {
    img: "https://cdn.msu.edu.in/logos/UGC.webp",
    alt: "Recognition of University Grants Commission (UGC)",
  },
    {
    img: NSDC,
    alt: "NSDC",
  },
  {
    img: "https://cdn.msu.edu.in/logos/govt-of-sikkim.jpg",
    alt: "govt-of-sikkim",
  },
  {
    img: "https://cdn.msu.edu.in/logos/NAPS.webp",
    alt: "NAPS",
  },
  {
    img: "https://cdn.msu.edu.in/logos/NATS.webp",
    alt: "NATS",
  },
  {
    img: "https://cdn.msu.edu.in/logos/DGT.webp",
    alt: "DGT",
  },
  {
    img: "https://cdn.msu.edu.in/logos/Skill-India-min.webp",
    alt: "Skill-India-min",
  },
  {
    img: TTAADC,
    alt: "DGT",
  },
];

const Certifications = () => {
  return (
    <section className="w-full py-6 md:py-14 lg:py-20 bg-[#F8F8F8] px-4 top_bottom_space">
      <div
        className="
        w-full mx-auto grid 
        grid-cols-3
        sm:grid-cols-3 
        md:grid-cols-4 
        lg:grid-cols-4 
        gap-8 md:gap-10 lg:gap-12
        items-center justify-items-center "
      >
        {approvals.map((logo, index) => (
          <div
            key={index}
            className="
              w-25 h-25 sm:w-32 sm:h-32 md:w-36 md:h-36  lg:w-43 lg:h-43 
              rounded-full bg-white 
              shadow-md hover:shadow-xl 
              border border-gray-200 
              flex items-center justify-center 
              p-5 md:p-7 overflow-hidden
              transition-all duration-300 
              hover:-translate-y-1
              hover:rotate-1 
              hover:border-orange-400
            "
          >
            <div className="relative w-full h-full">
              <Image
                src={logo.img}
                alt={logo.alt}
                width={1000}
                height={1000}
                className="object-contain w-full h-full"
              />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Certifications;
